import { Route } from 'vue-router';

export default class AuthGuard {

    /**
     * Checks if the application is in show room mode an handles the routing request based on the result
     * @param from
     * @param to
     * @param next
     */
    public static checkForShowRoomMode(from: Route, to: Route, next: any) {
        // It is not allowed to open the reader in the show room mode. Only show the library!
        if (process.env.VUE_APP_SHOW_ROOM_MODE === 'true') {
            next({ name: 'library_view' });
        } else {
            next();
        }
    }
}
